import {ClientId} from 'notebook/ELNConstants';
import {
  BaseTagValueStructuredTableColumn,
  StructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';
import {FIELD_TYPES} from 'schemas/fields/SchemaFieldConstants';

export default function canAttachFileToCellInTable<TTableMetadata, TRowMetadata>(
  [i, j]: Array<number>,
  structuredTable: StructuredTable<TTableMetadata, TRowMetadata>
): boolean {
  if (
    j < structuredTable.columns.length &&
    structuredTable.columns[j].columnType === TableColumnType.TAG_VALUE
  ) {
    const column = structuredTable.columns[j] as BaseTagValueStructuredTableColumn<ClientId>;
    if (column.schemaFieldType === FIELD_TYPES.BLOB_LINK.type) {
      return true;
    }
  }
  return false;
}
